import React from 'react';
import { Shield, TrendingUp, Award, Target, CheckCircle2 } from 'lucide-react';
import { Button } from '../ui/button';

const FinalSection = ({ onScheduleDemo }) => {
  const benefits = [
    {
      icon: Shield,
      title: "Mais Segurança",
      description: "Menor risco operacional"
    },
    {
      icon: TrendingUp,
      title: "Dados Reais",
      description: "Gestão e prestação de contas"
    },
    {
      icon: Award,
      title: "Mais Valor",
      description: "Diferenciação competitiva"
    }
  ];

  return (
    <section id="final" className="py-24 bg-gradient-to-br from-[#0f1a36] via-[#1a2847] to-[#0f1a36] relative overflow-hidden">
      {/* Animated background */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-20 left-10 w-96 h-96 bg-[#007bff] rounded-full mix-blend-multiply filter blur-3xl opacity-10 animate-pulse"></div>
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-[#008080] rounded-full mix-blend-multiply filter blur-3xl opacity-10 animate-pulse delay-1000"></div>
      </div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="max-w-5xl mx-auto">
          {/* Main content */}
          <div className="text-center mb-16">
            <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm px-4 py-2 rounded-full border border-white/20 mb-6">
              <Target className="w-4 h-4 text-[#008080]" />
              <span className="text-sm font-medium text-white">Próximos Passos</span>
            </div>
            
            <h2 className="text-4xl lg:text-6xl font-bold text-white mb-6">
              Transforme Seu Transporte Condominial
            </h2>
            
            <p className="text-xl lg:text-2xl text-gray-300 leading-relaxed max-w-3xl mx-auto">
              O WCOMPass oferece a governança operacional que sua empresa precisa para 
              se diferenciar no mercado e agregar valor real aos seus clientes.
            </p>
          </div>

          {/* Benefits grid */}
          <div className="grid md:grid-cols-3 gap-6 mb-16">
            {benefits.map((benefit, index) => {
              const Icon = benefit.icon;
              return (
                <div 
                  key={index}
                  className="bg-white/5 backdrop-blur-sm rounded-2xl p-8 border border-white/10 hover:border-[#007bff]/50 hover:bg-white/10 transition-all duration-300 text-center group"
                >
                  <div className="w-16 h-16 rounded-2xl bg-[#007bff]/20 flex items-center justify-center mx-auto mb-6 group-hover:scale-110 group-hover:bg-[#007bff]/30 transition-all duration-300">
                    <Icon className="w-8 h-8 text-[#007bff]" />
                  </div>
                  
                  <h3 className="text-2xl font-bold text-white mb-2">
                    {benefit.title}
                  </h3>
                  
                  <p className="text-gray-300 text-lg">
                    {benefit.description}
                  </p>
                </div>
              );
            })}
          </div>

          {/* Highlight box */}
          <div className="bg-gradient-to-r from-[#007bff] to-[#008080] rounded-3xl p-10 md:p-12 shadow-2xl mb-12">
            <div className="flex flex-col lg:flex-row items-center gap-8">
              <div className="flex-shrink-0">
                <div className="w-24 h-24 rounded-2xl bg-white/20 backdrop-blur-sm flex items-center justify-center">
                  <Award className="w-12 h-12 text-white" />
                </div>
              </div>
              
              <div className="text-white flex-grow">
                <h3 className="text-3xl font-bold mb-4">
                  Diferenciação para sua Empresa
                </h3>
                <p className="text-xl text-white/90 leading-relaxed mb-6">
                  Com o WCOMPass, a <span className="font-bold">sua empresa</span> se posiciona como líder em 
                  tecnologia e governança no transporte condominial, oferecendo ao seu cliente um serviço de excelência 
                  com evidências concretas e valor agregado.
                </p>
                
                <div className="flex flex-wrap gap-4">
                  <div className="flex items-center gap-2">
                    <CheckCircle2 className="w-5 h-5 text-white" />
                    <span className="text-white/90">Segurança Total</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <CheckCircle2 className="w-5 h-5 text-white" />
                    <span className="text-white/90">Dados Confiáveis</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <CheckCircle2 className="w-5 h-5 text-white" />
                    <span className="text-white/90">Vantagem Competitiva</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* CTA */}
          <div className="text-center">
            <h3 className="text-3xl font-bold text-white mb-6">
              Próximos Passos
            </h3>
            
            <div className="flex flex-col sm:flex-row gap-4 justify-center mb-8">
              <Button
                size="lg"
                onClick={onScheduleDemo}
                className="bg-white text-[#007bff] hover:bg-gray-100 px-10 py-7 text-xl font-bold rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-105"
              >
                Agendar Demo Agora
              </Button>
              
              <Button
                size="lg"
                variant="outline"
                onClick={() => window.open('mailto:contato@wcomdigital.com.br', '_blank')}
                className="border-2 border-white/30 text-white hover:bg-white/10 px-10 py-7 text-xl font-bold rounded-xl backdrop-blur-sm transition-all duration-300"
              >
                Falar com Especialista
              </Button>
            </div>

            <p className="text-gray-400 text-lg">
              Implantação em <span className="text-white font-semibold">30 dias</span> • 
              Piloto em <span className="text-white font-semibold">1 linha</span> • 
              Suporte <span className="text-white font-semibold">dedicado</span>
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FinalSection;
